export default class AchievementGrid {
	constructor(eventManager) {
		this.eventManager = eventManager;
		this.achievements = [];
		
		this.achievementSets = [];
	}
}
